export default "__VITE_ASSET__HvX_shDF__"